import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { authServices } from '../authServices'
import { SocialSignIndDTO, SocialSignInPayload } from '../authTypes'

import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useSignInWithGoogle = (
  options?: IOptionsUseMutation<SocialSignIndDTO>,
) => {
  const { t } = useTranslation()

  return useMutation<SocialSignIndDTO, ErrorDetail, SocialSignInPayload>({
    mutationFn: authServices.signInWithGoogle,
    onSuccess: (data: SocialSignIndDTO) => {
      if (options?.onSuccess) {
        options?.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      let errorMessage = t('api:errors.somethingWrong')

      if (
        code === ApiErrorCode.ACTION_IS_NOT_ALLOWED
        // ||
        // code === ApiErrorCode.ACCOUNT_DELETED
      ) {
        errorMessage = t('api:yourAccountIsDeleted')
      }

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage, code })
      }
    },
  })
}
